import script from "./Privacy.vue?vue&type=script&setup=true&lang=ts"
export * from "./Privacy.vue?vue&type=script&setup=true&lang=ts"

import "./Privacy.vue?vue&type=style&index=0&id=7f524614&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f524614"]])

export default __exports__